<template>
  <div class="out_wrap">
    <el-container>
      <el-main>
        <el-table :data="tableData" stripe v-if="!showInspection">
          <el-table-column label="编号" align="center" min-width="80px">
            <template slot-scope="{ $index }">
              {{ $index + 1 + (searchParam.page - 1) * searchParam.pageSize }}
            </template>
          </el-table-column>
          <el-table-column
            label="任务名称"
            show-overflow-tooltip
            align="center"
            prop="name"
            min-width="240px"
          >
          </el-table-column>
          <el-table-column label="操作" min-width="220px" align="center">
            <template slot-scope="scope">
              <div class="operateBtn-group">
                <el-button class="startInsp" @click="startInsp(scope.row)"
                  >开始巡检</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="paginationInfo.total && !showInspection"
          background
          :page-size.sync="searchParam.pageSize"
          :current-page.sync="searchParam.page"
          layout="prev, pager, next,slot"
          :pager-count="11"
          :total="paginationInfo.total"
          @current-change="getPages"
        >
          <span class="slot">{{
            "共" + paginationInfo.lastPage + "页," + paginationInfo.total + "条"
          }}</span>
        </el-pagination>
        <div class="inspDetail" v-if="showInspection">
          <div class="title">
            <p>{{ inspDetailInfo.name }}</p>
            <div class="operateBtn-group">
              <el-button class="endInsp" @click="endInsp(inspDetailInfo)"
                >结束巡检</el-button
              >
              <el-button class="inspMap" @click="inspMap(inspDetailInfo)"
                >巡检地图</el-button
              >
            </div>
          </div>

          <div class="inspDetail-content">
            <div class="loading" id="loading">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <iframe
              :src="
                'https://kc-res.izsw.net/apps/qrobot-inspection-system/zlmrtcclient/index1.html?data=' +
                  inspDetailInfo.hookUrl
              "
              frameborder="0"
            ></iframe>
            <div class="controlBtns">
              <div class="moveBtns">
                <el-image
                  src="https://kc-res.izsw.net/apps/qrobot-inspection-system/moveIconBg.png"
                  fit="contain"
                ></el-image>
                <div class="moveBtn"></div>
              </div>
              <div class="operateBtns">
                <el-image
                  src="https://kc-res.izsw.net/apps/qrobot-inspection-system/operateIconBg.png"
                  fit="contain"
                ></el-image>
                <el-button class="arrow-up"
                  ><el-image
                    src="https://kc-res.izsw.net/apps/qrobot-inspection-system/arrowUpIcon.png"
                  ></el-image>
                </el-button>
                <el-button class="arrow-right"
                  ><el-image
                    src="https://kc-res.izsw.net/apps/qrobot-inspection-system/arrowRightIcon.png"
                  ></el-image
                ></el-button>
                <el-button class="arrow-down"
                  ><el-image
                    src="https://kc-res.izsw.net/apps/qrobot-inspection-system/arrowDownIcon.png"
                  ></el-image
                ></el-button>
                <el-button class="arrow-left"
                  ><el-image
                    src="https://kc-res.izsw.net/apps/qrobot-inspection-system/arrowLeftIcon.png"
                  ></el-image
                ></el-button>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <footNav :active="activeNav"></footNav>
    </el-container>
    <!-- 巡检地图弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :visible.sync="inspectionMapVisible"
      class="inspectionMapDialog"
      width="1225px"
      center
    >
      <div class="dialog_content">
        <el-image :src="inspMapInfo.img" fit="contain"></el-image>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import footNav from "@/components/footNav";
import { taskList } from "@/assets/api/InspectionTaskMG";
export default {
  name: "RealTimeInspection",
  components: {
    footNav
  },
  watch: {
    $route(to, from) {
      this.$route.query.page &&
        (this.searchParam.page = this.$route.query.page * 1);
      this.getTableData();
    }
  },
  data() {
    return {
      activeNav: "3", // 当前选中nav
      tableData: [], // 表格数据
      // 搜索信息
      searchParam: {
        page: 1, // 当前页数
        pageSize: this.$store.state.limit // 每页条数
      },
      // 分页器信息
      paginationInfo: {
        total: 0, // 总条数
        lastPage: 0 // 总页数
      },
      showInspection: false, // 是否展示巡检详情
      inspDetailInfo: {}, // 巡检详情内容
      inspectionMapVisible: false, // 巡检地图弹框显隐
      inspMapInfo: {} // 巡检地图弹框信息
    };
  },
  created() {
    this.$route.query.page &&
      (this.searchParam.page = this.$route.query.page * 1);
    this.getTableData();
  },
  mounted() {},
  computed: {},
  methods: {
    // 获取巡检任务列表数据
    getTableData() {
      this.loading = true;
      taskList(this.searchParam).then(res => {
        const { code, data, msg } = res;
        if (code == 200) {
          if (!res.data.length && res.current_page > 1) {
            this.searchParam.page--;
            this.$router.replace(
              {
                name: "RealTimeInspection",
                query: {
                  page: this.searchParam.page
                }
              },
              () => {}
            );
            return;
          }
          this.tableData = data.data;
          this.tableData.forEach(item => {
            item.hookUrl = item.robot.hook_url ? item.robot.hook_url : null;
          });
          this.paginationInfo.total = data.total;
          this.paginationInfo.lastPage = data.last_page;
          this.loading = false;
        }
      });
    },

    // 页数切换
    getPages(page) {
      this.tableData = [];
      this.$router.replace(
        {
          name: "RealTimeInspection",
          query: {
            page
          }
        },
        () => {}
      );
    },

    // 巡检详情
    startInsp(row) {
      this.inspDetailInfo = row;
      this.showInspection = true;
    },
    // 结束巡检
    endInsp(row) {
      this.showInspection = false;
    },
    // 巡检地图
    inspMap(row) {
      // this.inspMapInfo = row;
      this.inspMapInfo = {
        img: "https://kc-res.izsw.net/apps/qrobot-inspection-system/map1.png"
      };
      this.inspectionMapVisible = true;
    }
  }
};
</script>
<style scoped lang="scss">
.out_wrap {
  .el-container {
    .el-main {
      position: relative;

      .inspDetail {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;

        .title {
          text-align: center;
          padding: 0 250px;
          margin: 0 50px;
          position: relative;

          p {
            line-height: 80px;
            font-size: $text-middleTitle;
            color: #ffffff;
          }

          .operateBtn-group {
            position: absolute;
            right: 0;
            top: 23px;

            /deep/ .el-button {
              background: url("https://kc-res.izsw.net/apps/qrobot-inspection-system/btnBg1.png")
                no-repeat center center/100% 100%;
              width: 120px;
              height: 42px;
              border: none;
              padding: 5px;

              span {
                font-size: $text-smallTitle;
                color: #ffffff;
                line-height: 1;
              }
            }
          }
        }

        .inspDetail-content {
          margin: 0 62px;
          position: relative;

          iframe {
            width: 1660px;
            height: 660px;
            position: relative;
          }

          .controlBtns {
            position: absolute;
            bottom: 36px;
            left: 30px;
            right: 30px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .moveBtns {
              width: 110px;
              height: 110px;
              position: relative;

              .el-image {
                width: 100%;
                height: 100%;
              }

              .moveBtn {
                width: 56px;
                height: 56px;
                position: absolute;
                left: 50%;
                top: 50%;
                margin-top: -28px;
                margin-left: -28px;
                background: url("https://kc-res.izsw.net/apps/qrobot-inspection-system/moveIcon.png")
                  no-repeat center center/100% 100%;
                cursor: pointer;
              }
            }

            .operateBtns {
              width: 110px;
              height: 110px;
              position: relative;

              .el-image {
                width: 100%;
                height: 100%;
              }

              & > .el-button {
                position: absolute;
                background: none;
                padding: 0;
                margin: 0;
                border: none;
              }

              .arrow-up {
                left: 50%;
                top: 12px;
                width: 21px;
                height: 16px;
                margin-left: -10.5px;
              }

              .arrow-right {
                right: 11px;
                top: 50%;
                width: 15px;
                height: 21px;
                margin-top: -9px;
              }

              .arrow-down {
                left: 50%;
                bottom: 7px;
                width: 20px;
                height: 16px;
                margin-left: -9px;
              }

              .arrow-left {
                left: 10px;
                top: 50%;
                width: 14px;
                height: 21px;
                margin-top: -9px;
              }
            }
          }

          .loading {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.8);
          }

          .loading.hide {
            display: none;
          }

          .loading div {
            position: absolute;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            left: 50%;
            top: 50%;
            margin-top: -14px;
            margin-left: -14px;
            background-color: #7b98e2;
            animation: loadTranslate 0.4s linear infinite alternate both;
          }

          .loading div:first-of-type {
            transform: rotate(0) translate(50px, 0px);
            animation-delay: 0.1s;
          }

          .loading div:nth-of-type(2) {
            transform: rotate(45deg) translate(50px, 0px);
            animation-delay: 0.2s;
          }

          .loading div:nth-of-type(3) {
            transform: rotate(90deg) translate(50px, 0px);
            animation-delay: 0.3s;
          }

          .loading div:nth-of-type(4) {
            transform: rotate(135deg) translate(50px, 0px);
            animation-delay: 0.4s;
          }

          .loading div:nth-of-type(5) {
            transform: rotate(180deg) translate(50px, 0px);
            animation-delay: 0.5s;
          }

          .loading div:nth-of-type(6) {
            transform: rotate(225deg) translate(50px, 0px);
            animation-delay: 0.6s;
          }

          .loading div:nth-of-type(7) {
            transform: rotate(270deg) translate(50px, 0px);
            animation-delay: 0.7s;
          }

          .loading div:nth-of-type(8) {
            transform: rotate(315deg) translate(50px, 0px);
            animation-delay: 0.8s;
          }

          @keyframes loadTranslate {
            from {
              width: 28px;
              height: 28px;
            }

            to {
              width: 0;
              height: 0;
            }
          }
        }
      }
    }
  }

  .inspectionMapDialog /deep/.el-dialog {
    height: 730px;
    background: url("https://kc-res.izsw.net/apps/qrobot-inspection-system/dialogBg730.png")
      no-repeat center center/100% 100%;

    .el-dialog__header {
      height: 100px;
    }

    .el-dialog__body {
      padding: 0 65px 25px;

      .dialog_content {
        .el-image {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RealTimeInspection.vue